import state from "./moduleInternationalShippingState.js";
import mutations from "./moduleInternationalShippingMutations.js";
import actions from "./moduleInternationalShippingActions.js";
import getters from "./moduleInternationalShippingGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
